const actions = {
  SET_STATE: 'pointredeem/SET_STATE',
  GET_TASKS: 'pointredeem/GET_TASKS',
}

export default actions
